import { render, staticRenderFns } from "./MotorBikeFrontDamage.vue?vue&type=template&id=c5d3d434"
import script from "./MotorBikeFrontDamage.vue?vue&type=script&lang=js"
export * from "./MotorBikeFrontDamage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports